module.exports = __webpack_public_path__ + "static/img/discount_bg.d1198d26.png";